"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var components_1 = require("@lsg/components");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var react_components_1 = require("@lws/react-components");

var CustomTeaserText_1 = require("./CustomTeaserText");

var CustomTeaserCTA_1 = require("./CustomTeaserCTA");

var CustomTeaserImage_1 = require("./CustomTeaserImage");

var utils_1 = require("../../utils");

var renderers_1 = require("../../utils/renderers");

exports.CustomTeaserComponent = function (_a) {
  var data = _a.data;

  var _b, _c;

  var label = data.text('label');
  var text = data.richText('text', utils_1.emptyDocument);
  var image = data.image('image');
  var ctaLabel = data.text('ctaLabel');
  var ctaTarget = data.text('ctaTarget');
  var ctaStyle = data["boolean"]('ctaStyle', false);
  var overlay = data.richText('overlay');
  var darkTheme = data["boolean"]('darkTheme');
  var videoId = data.number('videoId');
  var navigationName = data.text('navigationName');

  var _d = __read(react_1.useState(false), 2),
      open = _d[0],
      setOpen = _d[1];

  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(components_1.Theme, {
    look: darkTheme ? components_1.Themes.DARK : components_1.Themes.LIGHT
  }, react_1["default"].createElement(components_1.Section, {
    id: navigationName && navigationName
  }, react_1["default"].createElement(components_1.Grid, {
    verticalSpacing: (_b = components_1.Grid.Spacing) === null || _b === void 0 ? void 0 : _b.CONTAINER
  }, react_1["default"].createElement(GridRow_1.GridRow, {
    columnVariate: true
  }, react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 0,
    order: 0
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 1,
    order: 2
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 0,
    order: 3
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 0,
    order: 5
  }), image && react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 4,
    sm: 6,
    md: 6
  }, react_1["default"].createElement(CustomTeaserImage_1.CustomTeaserImage, {
    videoId: videoId,
    image: image
  })), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 4,
    sm: 6,
    md: image.fluid() ? 5 : 8,
    verticalAlign: (_c = components_1.Grid.VerticalAlign) === null || _c === void 0 ? void 0 : _c.MIDDLE,
    order: 4
  }, react_1["default"].createElement(CustomTeaserText_1.CustomTeaserText, {
    text: text,
    label: label
  }), !videoId && ctaLabel && (ctaTarget || overlay) && react_1["default"].createElement(CustomTeaserCTA_1.CustomTeaserCTA, {
    ctaLabel: ctaLabel,
    ctaTarget: ctaTarget,
    ctaStyle: ctaStyle,
    showOverlay: overlay && setOpen
  }))))), !videoId && overlay && react_1["default"].createElement(components_1.Layer, {
    htmlAttrs: {
      role: undefined
    },
    open: open,
    closeLinkLabel: "Schlie\xDFen",
    onCloseClick: function onCloseClick() {
      return setOpen(false);
    }
  }, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
    content: overlay,
    options: renderers_1.withFootnotesAndCustomBlocks
  }))));
};